import { useState } from 'react';

const useMergeState = initialState => {
	const [state, setState] = useState(initialState);
	const setMergedState = nextState => setState(prevState => ({ ...prevState, ...nextState }));
	return [state, setMergedState];
};

export default useMergeState;
